<template lang="pug">
  #subscription.page
      .columns
          .column.is-3-fullhd.is-4-desktop.is-6-tablet.is-12-mobile
              SubCard(@save="save" is-placeholder)
          .column.is-3-fullhd.is-4-desktop.is-6-tablet.is-12-mobile(v-for="sub of subs")
              SubCard(@save="save" :sub="sub")
</template>

<script>
import SubCard from "@/components/SubCard";

export default {
  name: "subscription",
  components: {
    SubCard
  },
  computed: {
    subs() {
      const list = this.$store.state.subscription.list || [];
      // системные статусы первыми, затем платные (порядок внутри групп сохраняется).
      // isSystem у платных может отсутствовать (aggregate не применяет дефолты) — приводим к 0/1.
      return [...list].sort(
        (a, b) => (b.isSystem ? 1 : 0) - (a.isSystem ? 1 : 0),
      );
    }
  },
  methods: {
    save(data) {
      this.$store.dispatch("setSubscription", data).catch(text => {
        this.$notify({
          type: "error",
          title: "Error",
          text
        });
      });
    }
  },
  created() {
    if (!this.$store.state.subscription.list.length) {
      this.$store
        .dispatch("getSubscription")
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Error",
            text
          });
        })
        .finally(() => {
          this.$store.commit("isLoading", {
            key: "subscriptions",
            status: false
          });
        });
    }
  }
};
</script>
